import _ from 'lodash';
import React from 'react';
import invariant from 'invariant';
import hoistNonReactStatics from 'hoist-non-react-statics';

import LoadingBlocks from 'components/forms/LoadingBlocks';
import { getPurchaseButton, getWorkflowStart } from 'services/api/microfwk';
import { purchaseButtonInfoService } from 'api/services/payway';
import { store } from '../../../../store';
import { getRegion } from 'utils/Region';

const withClaroPayment = WrappedComponent => {
  class ClaroPaymentGate extends React.PureComponent {
    state = {
      loading: null,
      claroPaymentEnabled: false,
      linkworkflowstart: '',
      hasSavedPayway: '',
    };

    async UNSAFE_componentWillMount() {
      this.setState({ loading: true });
      try {
        const query = _.get(this.props, ['location', 'query']);

        const LINK_WORKFLOW_START = _.get(query, 'linkworkflowstart');
        const OFFER_ID = _.get(query, 'offer_id');
        const GROUP_ID = _.get(query, 'group_id');
        const SEASON_ID = _.get(query, 'seasonId');
        const OBJ_TYPE = { object_type: 'A' };

        const GROUP_OR_OFFER = !GROUP_ID
          ? _.pickBy({ ...OBJ_TYPE, offer_id: OFFER_ID }, _.identity)
          : { group_id: GROUP_ID };

        let params = !LINK_WORKFLOW_START
          ? !_.isEmpty(GROUP_OR_OFFER)
            ? GROUP_OR_OFFER
            : OBJ_TYPE
          : LINK_WORKFLOW_START;

        const serviceToFetch = !LINK_WORKFLOW_START
          ? this.fetchPurchaseButton
          : this.fetchWorkflowstart;

        if (LINK_WORKFLOW_START && !_.isNil(SEASON_ID)) {
          params += `&season_id=${SEASON_ID}`;
        }

        const claroPaymentEnabled = await serviceToFetch(params);

        this.setState({ claroPaymentEnabled });
      } catch (error) {
        console.error(error);
      } finally {
        this.setState({ loading: false });
      }
    }

    fetchPurchaseButton = async payload => {
      try {
        const claroAdEnable =
          JSON.parse(
            store.getState().metadata?.cv_advertising_config || '{}',
          )?.[getRegion()]?.enable ||
          JSON.parse(store.getState().metadata?.cv_advertising_config || '{}')
            ?.default?.enable;
        const request = await purchaseButtonInfoService({
          ...payload,
          claroAdEnable: claroAdEnable,
        }).then(({ data }) => data);
        const { status, errors, response } = request;

        invariant(
          _.parseInt(status) === 0 && _.isEmpty(errors),
          `(withClaroPayment/ClaroPaymentGate...) fetchPurchaseButton: Missing parameters `,
        );

        const LINK_WORKFLOW_START = _.get(response, [
          'listButtons',
          'button',
          '0',
          'linkworkflowstart',
        ]);

        this.setState({ linkworkflowstart: LINK_WORKFLOW_START });

        if (typeof LINK_WORKFLOW_START === 'undefined') {
          return true;
        }

        return this.fetchWorkflowstart(LINK_WORKFLOW_START);
      } catch (error) {
        throw error;
      }
    };

    fetchWorkflowstart = async linkworkflowstart => {
      try {
        const user = window.utils.userType.checkUserData();
        const params = user && user.user_id && { user_id: user.user_id };
        const request = await getWorkflowStart(linkworkflowstart, params);
        const { status, errors, response } = request;
        this.setState({ hasSavedPayway: response.hasSavedPayway });

        invariant(
          _.parseInt(status) === 0 && _.isEmpty(errors),
          `(withClaroPayment/ClaroPaymentGate...) fetchWorkflowstart: Missing parameters `,
        );

        const paths = ['workflow.listBuyLinks', 'list'];

        const claroPaymentEnabled = _.flow(
          obj => _.map(paths, path => _.get(obj, path)),
          _.compact,
          _.flatten,
          col => _.some(col, { gateway: 'claropagosgate' }),
        )(response);

        return claroPaymentEnabled;
      } catch (error) {
        throw error;
      }
    };

    render() {
      const {
        loading,
        claroPaymentEnabled,
        linkworkflowstart,
        hasSavedPayway,
      } = this.state;
      const { search } = location;
      if (loading && !search?.includes('micuentafull')) return <LoadingBlocks />;

      return (
        <WrappedComponent
          {...this.props}
          claroPaymentEnabled={claroPaymentEnabled}
          linkworkflowstart={linkworkflowstart}
          hasSavedPayway={hasSavedPayway}
        />
      );
    }
  }

  hoistNonReactStatics(ClaroPaymentGate, WrappedComponent);

  return ClaroPaymentGate;
};

export default withClaroPayment;
